import { Requester } from './Requester';
import { ISurveyFull } from '../types';

export const ReopenSurvey = async ({ surveyId }: { surveyId: string }): Promise<ISurveyFull | null> => {
    try {
        const response = await Requester<ISurveyFull>({
            path: `surveys/${surveyId}/review/reopen`,
            method: 'PATCH'
        });

        return '_id' in response ? response : null;
    } catch (e) {
        console.error('Reopen survey request failed');
        return Promise.reject(e);
    }
};
